module.exports = __webpack_public_path__ + "static/media/synchro.35046fb1.svg";